exports.components = {
  "component---src-pages-about-janet-js": () => import("./../../../src/pages/about-janet.js" /* webpackChunkName: "component---src-pages-about-janet-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

